import ready from "./ready";
import lottieplayer from "./lottieplayer";
import faqAnimation from "./helpers/faqAnimation";
import cardAnimation from "./helpers/cardAnimation";
import stickyFilter from "./helpers/stickyFilter";
import swiper from "./swiper";

ready(() => {
    swiper()
    cardAnimation()
    lottieplayer()
    faqAnimation()
    stickyFilter()
})